import React from "react";
import { RoutineAndActivity } from "us.collection.routines-and-activities/components";
import { useNavigate, useLocation } from "react-router-dom";
import { INavigationData } from 'us.collection/interfaces';

interface ICnt_Sentences {
  caseNo: number;
}

const Cnt_Sentences: React.FC<ICnt_Sentences> = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as INavigationData;

  const onMinimize = (url: string) => {
    navigate(url, { state });
  };

  return (
    <RoutineAndActivity onMinimize={onMinimize} {...props}></RoutineAndActivity>
  );
};

export default Cnt_Sentences;
